import styled from 'styled-components';

export const StyledCanvas = styled.canvas`
  position: absolute;
  background-color: rgba(21, 28, 43, 1);
  border-radius: 0.5rem;
  z-index: -1;
`;
